// Grocery sticky cart bar (phones). Floats above the bottom tab bar: item
// count + basket total on the left, "View cart" on the right.
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Grid } from 'antd';
import { RightOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { useActiveCart } from '@core/hooks/useCart';
import Price from '@components/base/Price';
import { useCopy } from '@/app/providers/useCopy';

export default function MobileCartBarGrocery() {
  const t = useCopy();
  const screens = Grid.useBreakpoint();
  const hasResolvedBreakpoint = Object.keys(screens).length > 0;
  const isMobile = hasResolvedBreakpoint && !screens.sm;
  const { cart, lineCount } = useActiveCart();
  const { pathname } = useLocation();
  const isVisible = isMobile && lineCount > 0 && pathname !== '/cart' && pathname !== '/checkout';

  useEffect(() => {
    document.documentElement.classList.toggle('grocery-mobile-cart-bar-active', isVisible);
    return () => {
      document.documentElement.classList.remove('grocery-mobile-cart-bar-active');
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="grocery-mobile-cart-bar gx-cartbar">
      <span className="gx-cartbar__icon" aria-hidden>
        <ShoppingCartOutlined />
      </span>
      <div className="gx-cartbar__summary">
        <strong>
          {lineCount} {lineCount === 1 ? t('item', 'item') : t('items', 'items')}
        </strong>
        <Price amount={cart?.grandTotal ?? cart?.subtotal ?? 0} />
      </div>
      <Link to="/cart" className="gx-cartbar__cta">
        {t('viewCart', 'View cart')} <RightOutlined />
      </Link>
    </div>
  );
}
